<template>
  <!-- viewBox по границам круга (0.797…23.297): с исходным «0 0 24 24» вокруг
       иконки оставались поля, и рядом с ВК и Дзеном она выглядела мельче -->
  <svg width="30" height="30" viewBox="0.797 0.797 22.5 22.5" xmlns="http://www.w3.org/2000/svg">
    <g clip-path="url(#clip0_369_825)">
      <path
        d="M12.0469 0.796875C5.83216 0.796875 0.796875 5.83216 0.796875 12.0469C0.796875 18.2616 5.83216 23.2969 12.0469 23.2969C18.2616 23.2969 23.2969 18.2616 23.2969 12.0469C23.2969 5.83216 18.2616 0.796875 12.0469 0.796875ZM17.5721 8.50403L15.7258 17.2046C15.5897 17.8216 15.2223 17.9713 14.7097 17.6809L11.8972 15.6079L10.5408 16.9143C10.3911 17.064 10.2641 17.191 9.97379 17.191L10.1734 14.3286L15.3856 9.61996C15.6124 9.42036 15.3357 9.30696 15.0363 9.50655L8.59476 13.562L5.81855 12.6956C5.21522 12.505 5.20161 12.0922 5.94556 11.8019L16.7918 7.61946C17.2954 7.438 17.7354 7.74194 17.5721 8.50403Z"
        :fill="currentColor"
      />
    </g>
    <defs>
      <clipPath id="clip0_369_825">
        <rect width="24" height="24" :fill="currentColor" />
      </clipPath>
    </defs>
  </svg>
</template>

<script lang="ts" setup>
  withDefaults(
    defineProps<{
      currentColor?: string;
    }>(),
    {
      currentColor: "text-txprimary",
    }
  );
</script>
